export default defineNuxtRouteMiddleware(async (to) => {
  const { checkAccess } = useLabsGuard()

  return await checkAccess(to)
})
